export default __webpack_public_path__ + "static/media/fondo-login-dtm.b2e4913d.JPG";